import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'

const TOKEN_KEY = 'haixiaCardBagToken'

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  sessionStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  sessionStorage.removeItem(TOKEN_KEY)
}

/**
 * 海峡卡包-获取验证码
 */
export function sendCaptcha(data) {
  return request({
    url: `${apiConfig.ZY}/haiXiaBag/sendCaptcha`,
    method: 'post',
    data
  })
}

/**
 * 海峡卡包-登录（手机号 + 验证码），data 为 token 字符串
 */
export function login(data) {
  return request({
    url: `${apiConfig.ZY}/haiXiaBag/login`,
    method: 'post',
    data
  })
}

/**
 * 海峡卡包-分页查询卡包
 * 字段：ordNo / ordSubNo / gcName / gcDenomination / expireTime /
 * cardNo / cardPwd / shortUrl / verifyCode / redeemCode /
 * codeType：0卡号卡密 1卡密 2短链 3短链验证码 4兑换码
 * redeCodeStatus：0未使用 1兑换中 2已使用 3已过期 4已出库待发放
 * 5已退货 6已延期 7已冻结 8异常 9到期（预扣回款）
 * gcDenomination：面值，单位万分之一元，前端展示需 /10000
 */
export function getOrderPages(data = {}) {
  return request({
    url: `${apiConfig.ZY}/haiXiaBag/order/pages`,
    method: 'post',
    token: getToken(),
    data
  })
}
